import React, { useEffect, useState } from "react";
import {
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Spinner
} from "reactstrap";
import CheckCircleRounded from "../../assets/images/icons/CheckCircleRounded";
import AlertTriangeMono from "../../assets/images/icons/AlertTriangeMono";
import { useLocation } from "react-router-dom";
import { Client, Databases } from "appwrite";
import { withTranslation } from "react-i18next";

function CmsRessources(props) {
  const [client_data, setCompanyInfos] = useState(undefined);
  const [cmsDropdown, setCmsDropdown] = useState(false);
  const [selectedCms, setSelectedCms] = useState("Woocommerce");
  const { state } = useLocation();

  const getClientData = async function () {
    const client = new Client();

    const databases = new Databases(client, "default");

    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    const promise = databases.getDocument(
      "default",
      "client_infos",
      localStorage.getItem("companyId")
    );

    promise.then(
      function (response) {
        setCompanyInfos(response);
        console.log("company info is ", response);
        if (response.shopify_token) {
          setSelectedCms("Shopify");
        }
        return response;
      },
      function (error) {
        console.log(error);
        return null;
      }
    );
  };

  const svgs = {
    timezone: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
      >
        <g filter="url(#filter0_d_1148_1762)">
          <rect
            x="12"
            y="8"
            width="40"
            height="40"
            rx="6.75556"
            fill="#FFFAF1"
          />
        </g>
        <path
          style={{
            strokeWidth: "3",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }}
          d="M25 24L32.5 32L40 24"
          stroke="#FFA412"
        />
        <defs>
          <filter
            id="filter0_d_1148_1762"
            x="0.9"
            y="0.9"
            width="62.2"
            height="62.2"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="5.55" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_1148_1762"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_1148_1762"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    ),
    plus_icon: (
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.01667 13.7836C6.62474 13.7836 6.32189 13.6767 6.10811 13.4629C5.89433 13.2313 5.78744 12.9195 5.78744 12.5276V8.14517H1.48517C1.11106 8.14517 0.817111 8.04719 0.603333 7.85123C0.389556 7.63745 0.282667 7.34351 0.282667 6.96939C0.282667 6.59528 0.389556 6.31025 0.603333 6.11428C0.817111 5.9005 1.11106 5.79362 1.48517 5.79362H5.78744V1.54478C5.78744 1.15286 5.89433 0.850005 6.10811 0.636227C6.32189 0.422449 6.63365 0.315561 7.04339 0.315561C7.43532 0.315561 7.72926 0.422449 7.92522 0.636227C8.139 0.850005 8.24589 1.15286 8.24589 1.54478V5.79362H12.5482C12.9401 5.79362 13.234 5.9005 13.43 6.11428C13.6438 6.31025 13.7507 6.59528 13.7507 6.96939C13.7507 7.34351 13.6438 7.63745 13.43 7.85123C13.234 8.04719 12.9401 8.14517 12.5482 8.14517H8.24589V12.5276C8.24589 12.9195 8.139 13.2313 7.92522 13.4629C7.72926 13.6767 7.42641 13.7836 7.01667 13.7836Z"
          fill="currentColor"
        />
      </svg>
    ),
    check_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="15"
        viewBox="0 0 21 15"
        fill="none"
      >
        <path
          d="M20.9949 2.0168C20.8615 2.5003 20.5279 2.84638 20.1842 3.18738C16.4077 6.92815 12.6313 10.674 8.86001 14.4199C8.44439 14.8321 7.96721 15.051 7.37201 14.9899C6.96153 14.9492 6.61775 14.7609 6.33041 14.4759C4.39089 12.5571 2.45136 10.6435 0.52723 8.71456C-0.334782 7.84934 -0.103886 6.5159 0.958235 5.99677C1.62014 5.67105 2.36927 5.81355 2.94394 6.38357C4.16512 7.59487 5.38631 8.80617 6.60749 10.0175C6.88456 10.2923 7.16164 10.562 7.43358 10.8369C7.53107 10.9387 7.60291 10.9387 7.7004 10.8369C7.9826 10.5468 8.2802 10.2618 8.56754 9.97166C11.7077 6.85689 14.853 3.73704 17.9932 0.622277C18.4088 0.210029 18.8758 -0.0444449 19.4863 0.00644996C20.1483 0.0624343 20.7383 0.520488 20.9333 1.15158C20.9538 1.20757 20.9795 1.26355 21 1.31954C20.9949 1.55365 20.9949 1.78268 20.9949 2.0168Z"
          fill="white"
        />
      </svg>
    ),
    close_icon: (
      <svg
        width="11"
        height="12"
        viewBox="0 0 11 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.36078 3.13406C7.5521 2.93171 7.89946 2.92198 8.10181 3.11331L8.4827 3.47345C8.69695 3.67602 8.69477 4.01213 8.50345 4.21448L6.88282 5.92849L8.59683 7.54912C8.81108 7.7517 8.80891 8.0878 8.61758 8.29015L8.25744 8.67104C8.05486 8.88529 7.73066 8.89437 7.51641 8.69179L5.8024 7.07116L4.18177 8.78517C3.97919 8.99942 3.65499 9.0085 3.44074 8.80592L3.05985 8.44578C2.8575 8.25446 2.83652 7.919 3.0391 7.70475L4.65973 5.99074L2.94572 4.37011C2.74337 4.17879 2.72239 3.84333 2.92497 3.62908L3.28511 3.24819C3.47643 3.04584 3.82379 3.03612 4.02614 3.22744L5.74015 4.84807L7.36078 3.13406Z"
          fill="#563BFF"
        />
      </svg>
    ),
    folder_icon: (
      <svg
        width="19"
        height="12"
        viewBox="0 0 19 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.4688 5C17.6562 5 18.375 6.3125 17.75 7.3125L15.25 11.3125C14.9688 11.75 14.5 12 14 12H1.5C0.65625 12 0 11.3438 0 10.5V1.5C0 0.6875 0.65625 0 1.5 0H6.5L8.5 2H13.5C14.3125 2 15 2.6875 15 3.5V5H16.4688ZM1.5 1.6875V9L3.4375 5.75C3.71875 5.28125 4.21875 5 4.75 5H13.5V3.6875C13.5 3.59375 13.4062 3.5 13.3125 3.5H7.875L5.875 1.5H1.6875C1.5625 1.5 1.5 1.59375 1.5 1.6875ZM14 10.5L16.5 6.5H4.65625L2.25 10.5H14Z"
          fill="#737791"
        />
      </svg>
    ),
    shopify_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 256 292"
      >
        <path
          fill="#95BF46"
          d="M223.774 57.34c-.201-1.46-1.48-2.268-2.537-2.357a19614 19614 0 0 0-23.383-1.743s-15.507-15.395-17.209-17.099c-1.703-1.703-5.029-1.185-6.32-.805c-.19.056-3.388 1.043-8.678 2.68c-5.18-14.906-14.322-28.604-30.405-28.604c-.444 0-.901.018-1.358.044C129.31 3.407 123.644.779 118.75.779c-37.465 0-55.364 46.835-60.976 70.635c-14.558 4.511-24.9 7.718-26.221 8.133c-8.126 2.549-8.383 2.805-9.45 10.462C21.3 95.806.038 260.235.038 260.235l165.678 31.042l89.77-19.42S223.973 58.8 223.775 57.34M156.49 40.848l-14.019 4.339c.005-.988.01-1.96.01-3.023c0-9.264-1.286-16.723-3.349-22.636c8.287 1.04 13.806 10.469 17.358 21.32m-27.638-19.483c2.304 5.773 3.802 14.058 3.802 25.238c0 .572-.005 1.095-.01 1.624c-9.117 2.824-19.024 5.89-28.953 8.966c5.575-21.516 16.025-31.908 25.161-35.828m-11.131-10.537c1.617 0 3.246.549 4.805 1.622c-12.007 5.65-24.877 19.88-30.312 48.297l-22.886 7.088C75.694 46.16 90.81 10.828 117.72 10.828"
        />
        <path
          fill="#5E8E3E"
          d="M221.237 54.983a19614 19614 0 0 0-23.383-1.743s-15.507-15.395-17.209-17.099c-.637-.634-1.496-.959-2.394-1.099l-12.527 256.233l89.762-19.418S223.972 58.8 223.774 57.34c-.201-1.46-1.48-2.268-2.537-2.357"
        />
        <path
          fill="#FFF"
          d="m135.242 104.585l-11.069 32.926s-9.698-5.176-21.586-5.176c-17.428 0-18.305 10.937-18.305 13.693c0 15.038 39.2 20.8 39.2 56.024c0 27.713-17.577 45.558-41.277 45.558c-28.44 0-42.984-17.7-42.984-17.7l7.615-25.16s14.95 12.835 27.565 12.835c8.243 0 11.596-6.49 11.596-11.232c0-19.616-32.16-20.491-32.16-52.724c0-27.129 19.472-53.382 58.778-53.382c15.145 0 22.627 4.338 22.627 4.338"
        />
      </svg>
    ),
    woocommerce_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 128 128"
      >
        <path
          fill="#7f54b3"
          d="M116.3 89.1H11.7C5.2 89.1 0 83.9 0 77.4v-40C0 31 5.2 25.8 11.7 25.8h104.7c6.4 0 11.7 5.2 11.7 11.7v40c-.1 6.4-5.3 11.6-11.8 11.6"
        />
        <path
          fill="#FFF"
          d="M13.8 76.7s2.8 11.8 8.5 3.9s11.2-20.3 11.2-20.3s.4-3.1 2 3.7S44 80 44 80s6.3 7.9 8.9-.4c-1-11 2.8-31 6.7-40.6c1.6-8.5-7.3-6.1-8.1-4.1s-6.3 14.8-6.7 28.2c0 0-4.7-12.8-5.1-17.4c-.4-4.7-5.3-5.9-8.1-1.4S20.3 66.2 20.3 66.2l-5.5-28.4s-5.5-7.3-8.7 1.6c0 0 5.7 34.9 7.7 37.3m73.2-31c-8.5-14.2-21.1-3.4-21.1-3.4s-9.6 11.1-5.3 26.2c6.9 14.9 16.6 8.3 19.2 7.1c2.7-1.3 14.1-14.3 7.2-29.9m-6.5 12.5c0 5.9-4.9 11.4-8.9 10.2c-2.2-1.3-3.6-4.8-3.6-10.8c2-9.7 6.4-11 8.7-10.8c4.3 2.3 4.1 7.4 3.8 11.4m38.4-12.5c-8.5-14.2-21.1-3.4-21.1-3.4s-9.6 11.1-5.3 26.2c6.9 14.9 16.6 8.3 19.2 7.1c2.6-1.3 14.1-14.3 7.2-29.9m-6.5 12.5c0 5.9-4.9 11.4-8.9 10.2c-2.2-1.3-3.6-4.8-3.6-10.8c2-9.7 6.4-11 8.7-10.8c4.2 2.3 4 7.4 3.8 11.4"
        />
        <path fill="#7f54b3" d="m61.3 89.1l22.3 13.1l-4.7-13.1l-12.8-3.6z" />
      </svg>
    ),
    magento_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 128 128"
      >
        <path
          fill="#f26322"
          d="M119.82 31.97v64.01l-15.85 9.12V41.17l-39.62-22.9l-39.64 22.9l.1 63.96l-15.82-9.15V32.02L64.45 0zM72.3 105.1l-7.9 4.6l-7.95-4.55V41.17l-15.82 9.15l.03 63.96L64.38 128l23.77-13.72V50.29L72.3 41.14z"
        />
      </svg>
    ),
    prestashop_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path
          fill="currentColor"
          d="M11.558 1.034C5.174 1.034 0 6.21 0 12.592c0 1.258.201 2.47.574 3.597l.002-.007a12.4 12.4 0 0 1 .53-1.787l.011-.03q.129-.333.277-.66l.084-.181q.12-.256.253-.507q.053-.102.108-.203c.02-.038.044-.073.064-.11q.14-.25.29-.493l.075-.114q.187-.292.393-.573l.035-.05q.217-.289.451-.563l.1-.118q.232-.266.481-.517l.099-.097a10 10 0 0 1 .546-.503c.74-2.48 3.005-4.285 5.686-4.285c1.079 0 2.152.31 3.071.873a6 6 0 0 1 2.211 2.407l.007.015l.04.074v.003l.004.002a10 10 0 0 1 1.567 1.198l.12.109c.002 0 .006.005.007.006l-.002-.006l-.001-.004v-.003l.042-.084c.377-2.384 1.43-4.102 2.67-4.102c.934 0 1.762.975 2.276 2.476l.005.016l.001.002q.218.236.424.521l.007.01l.021.067l-.02-.078c-1.542-4.569-5.863-7.857-10.952-7.857zM9.927 5.477C7.586 5.52 5.34 7.132 4.574 9.365l-.012.034a10 10 0 0 1 1.315-.895c2.806-1.656 6.479-1.646 9.278.016c-.895-1.653-2.631-2.819-4.5-3.004a5 5 0 0 0-.728-.039m9.834.5a1.4 1.4 0 0 0-.39.067c-1.265.562-1.719 2.073-2.031 3.303l-.016.072c.365-.62.808-1.215 1.396-1.642c.835-.687 2.105-.655 2.916.053c.308.326.141.008.031-.22c-.342-.75-1.025-1.653-1.906-1.634zM12.35 8.315l-1.07 3.27l-.002.005l-.006.002l-4.498 1.112h-.009l4.456 1.087q.159.166.36.28h.002q.063.035.129.065l.01.005q.062.026.126.047l.021.008q.06.019.12.032l.033.008a1.7 1.7 0 0 0 .318.033a1.55 1.55 0 0 0 1.43-.948c.08-.186.123-.39.123-.604v-.011l-.001-.012a2 2 0 0 0-.01-.16l-.001-.002a2 2 0 0 0-.026-.153l-.001-.004a1.5 1.5 0 0 0-.096-.288v-.003a1.5 1.5 0 0 0-.348-.49v-.003zm3.148.626c.048 1.008.036 2.046-.1 3.057c-.17 2.018-1.19 3.798-1.972 5.616l-.03.08l-.035.086c1.51-1.522 3.17-3.04 3.969-5.082c.383-.636.118-1.342-.115-1.976c-.17-.877-1.069-1.278-1.717-1.781m6.172.572l-.588 2.688a2 2 0 0 0-.047.2l-.01.06a2 2 0 0 0-.016.222l-.002.031h.003c0 .628.297 1.136.663 1.137a.4.4 0 0 0 .182-.045l.027-.015l.07-.047q.019-.016.036-.033a.8.8 0 0 0 .137-.168l.03-.054a1 1 0 0 0 .052-.108l.017-.04q.03-.08.053-.166l.002-.002l.001-.003l.404-.451l-.407-.456v.001l-.02-.063zm-4.381.856c.69 1.716.85 3.707.091 5.43c-.49 1.368-1.587 2.463-1.874 3.905q1.096.172 2.21.186c2.166.029 4.332-.42 6.284-1.365c-2.04-2.869-4.121-5.755-6.711-8.156m-4.948.977a.583.583 0 1 1 0 1.166a.583.583 0 0 1 0-1.166m9.352.37c.138 0 .249.19.249.426s-.111.426-.249.426c-.137 0-.248-.19-.248-.426c0-.235.11-.426.248-.426m-4.044.184a5 5 0 0 1-.05.29l-.006.023q-.016.076-.033.128c-.48 1.417-1.275 2.52-2.36 3.697q-.221.239-.459.484a59 59 0 0 1-1.196 1.205c-.112.11-.259.261-.425.436c-.103.287-.22.61-.318.95q-.065-.023-.131-.049c-2.108-.815-3.519-1.904-3.519-1.904s1.086 1.414 2.915 2.74q.265.192.522.339c-.075 1.194.452 2.34 2.83 2.682a4.8 4.8 0 0 0 1.228.008l-.01-.029l-.004-.01s-.167-.133-.379-.377a3.8 3.8 0 0 1-.584-.897a3.4 3.4 0 0 1-.266-.862a3.2 3.2 0 0 1-.006-.972q.025-.18.072-.366c.093-.374.255-.772.507-1.192l.002-.003l.241-.404c1.103-1.86 1.797-3.275 1.506-5.441a9 9 0 0 0-.078-.476zm4.681.779l.003.036v.01l-.003.038l.003-.043q0-.02-.003-.04zm-.012.275l-.002.01l-.002.014zm1.353 5.928c-2.553 1.138-5.44 1.44-8.192 1.007c-.14 1.108.384 2.218 1.214 2.93l.012.01c2.703-.433 4.975-2.168 6.966-3.946z"
        />
      </svg>
    ),
    e_commerce: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="2.5em"
        height="2.5em"
        viewBox="0 0 24 24"
      >
        <path
          fill="#96BF48"
          d="M14.5 21.991V18.5c0-.935 0-1.402-.201-1.75a1.5 1.5 0 0 0-.549-.549C13.402 16 12.935 16 12 16s-1.402 0-1.75.201a1.5 1.5 0 0 0-.549.549c-.201.348-.201.815-.201 1.75v3.491z"
        ></path>
        <path
          fill="#96BF48"
          fillRule="evenodd"
          d="M5.732 12c-.89 0-1.679-.376-2.232-.967V14c0 3.771 0 5.657 1.172 6.828c.943.944 2.348 1.127 4.828 1.163h5c2.48-.036 3.885-.22 4.828-1.163C20.5 19.657 20.5 17.771 20.5 14v-2.966a3.06 3.06 0 0 1-5.275-1.789l-.073-.728a3.167 3.167 0 1 1-6.307.038l-.069.69A3.06 3.06 0 0 1 5.732 12m8.768 6.5v3.491h-5V18.5c0-.935 0-1.402.201-1.75a1.5 1.5 0 0 1 .549-.549C10.598 16 11.065 16 12 16s1.402 0 1.75.201a1.5 1.5 0 0 1 .549.549c.201.348.201.815.201 1.75"
          clipRule="evenodd"
          opacity=".5"
        ></path>
        <path
          fill="#96BF48"
          d="M9.5 2h5l.652 6.517a3.167 3.167 0 1 1-6.304 0z"
        ></path>
        <path
          fill="#96BF48"
          d="M3.33 5.351c.178-.89.267-1.335.448-1.696a3 3 0 0 1 1.889-1.548C6.057 2 6.51 2 7.418 2h2.083l-.725 7.245a3.06 3.06 0 1 1-6.044-.904zm17.34 0c-.178-.89-.267-1.335-.448-1.696a3 3 0 0 0-1.888-1.548C17.944 2 17.49 2 16.582 2H14.5l.725 7.245a3.06 3.06 0 1 0 6.043-.904z"
          opacity=".7"
        ></path>
      </svg>
    )
  };

  useEffect(() => {
    getClientData();
  }, []);

  useEffect(() => {
    if (state && state.auth === "prestashop") {
      setSelectedCms("Prestashop");
    }
  }, [state]);

  return (
    <React.Fragment>
      {client_data ? (
        <div
          className="store-connection"
          style={{
            borderRadius: "15px",
            background: "#FFF",
            boxShadow: "0px 6px 24px 1px rgba(53, 22, 252, 0.10)",
            padding: "41px 80px 60px 65px"
          }}
        >
          <Row className="mb-3">
            <div className="d-flex align-items-center flex-wrap gap-2">
              <span className="font-primary">
                <div className="stepTitle font-primary">
                  {props.t("Connecter votre E-commerce")}
                </div>
              </span>
            </div>
            <div>{props.t("general_shopify_subtitle_1")}</div>
          </Row>
          <div className="d-flex row">
            <div className="d-flex gap-3 align-items-center">
              <label
                className="font-primary mb-0"
                style={{
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: "600",
                  lineHeight: "normal"
                }}
              >
                {props.t("Votre CMS")} :
              </label>
              <Dropdown
                isOpen={cmsDropdown}
                toggle={() => setCmsDropdown(!cmsDropdown)}
              >
                <DropdownToggle
                  tag="button"
                  className="form-control py-0"
                  style={{
                    textTransform: "capitalize",
                    height: "55px",
                    border: "none",
                    borderRadius: "10px",
                    background: "#f7f8fb",
                    color: "#737791",
                    fontSize: "15px",
                    fontStyle: "normal",
                    fontWeight: "400",
                    lineHeight: "normal"
                  }}
                >
                  {selectedCms === "Shopify"
                    ? svgs.shopify_icon
                    : selectedCms === "Woocommerce"
                    ? svgs.woocommerce_icon
                    : selectedCms === "Magento"
                    ? svgs.magento_icon
                    : svgs.prestashop_icon}{" "}
                  {selectedCms}
                  <i className="ms-2 mdi mdi-chevron-down" />
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-lg-end">
                  <DropdownItem
                    onClick={() => {
                      setSelectedCms("Woocommerce");
                    }}
                  >
                    Woocommerce
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => {
                      setSelectedCms("Magento");
                    }}
                  >
                    Magento
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => {
                      setSelectedCms("Shopify");
                    }}
                  >
                    Shopify
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => {
                      setSelectedCms("Prestashop");
                    }}
                  >
                    Prestashop
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
            {selectedCms === "Shopify" ? (
              <div
                className="align-items-center"
                style={{
                  margin: "30px 30px 0px 0px"
                }}
              >
                <div className="col-auto">
                  <div className="font-primary">
                    {client_data &&
                      client_data.shopify_token &&
                      client_data.shopify_store_url && (
                        <>
                          <div>
                            {props.t(
                              "La connexion à votre boutique est active"
                            )}{" "}
                            <span style={{ color: "#563BFF" }}>
                              <CheckCircleRounded width={24} height={24} />
                            </span>
                            <div style={{ fontWeight: "500" }}>
                              {props.t("URL de la boutique")} :{" "}
                              <span
                                className="badge p-1"
                                style={{
                                  borderRadius: "10px",
                                  backgroundColor: "#d7fee1",
                                  color: "#046c28"
                                }}
                              >
                                {client_data.shopify_store_url}
                              </span>
                            </div>
                          </div>
                        </>
                      )}
                  </div>
                </div>

                {client_data &&
                  (!client_data.shopify_token ||
                    !client_data.shopify_store_url) && (
                    <>
                      <Col lg="6" className="">
                        <div className="mt-3 font-primary d-flex align-items-center gap-2">
                          {props.t(
                            "Connexion non établie. Installez Synibox pour"
                          )}
                          {` ${selectedCms}`}
                          <AlertTriangeMono
                            width={"30px"}
                            height={"30px"}
                            className=""
                          />
                        </div>
                        <button
                          type="button"
                          className="view-button mt-2"
                          style={{
                            backgroundColor: "#563BFF"
                          }}
                          onClick={() => {
                            window.location.href =
                              "https://apps.shopify.com/synibox";
                          }}
                        >
                          {props.t("Install Shopify App")}
                        </button>
                      </Col>
                    </>
                  )}
              </div>
            ) : (
              <div className="mt-3 ms-4 font-primary ">
                <div className="d-flex align-items-center gap-2">
                  {props.t("Bientôt disponible")}{" "}
                  <AlertTriangeMono
                    width={"30px"}
                    height={"30px"}
                    className=""
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div style={{ textAlign: "center", fontSize: "14px" }}>
          <Spinner
            className="me-1"
            style={{ height: "15px", width: "15px" }}
            animation="border"
          />
          {props.t("Chargement") + "..."}
        </div>
      )}
    </React.Fragment>
  );
}

export default withTranslation()(CmsRessources);
